import React from "react";
import { Typography } from "antd";
import { CheckOutlined, CopyOutlined } from "@ant-design/icons";

export default function CopyableText({
  value,
  displayValue,
  className = "",
  showTooltip = true,
  stopPropagation = true,
}) {
  const rawValue = value == null ? "" : String(value);
  const textToShow = displayValue ?? rawValue;

  if (!rawValue) {
    return <span className={className}>None</span>;
  }

  return (
    <span
      className={className}
      onClick={(e) => {
        if (stopPropagation) e.stopPropagation();
      }}
      onMouseDown={(e) => {
        if (stopPropagation) e.stopPropagation();
      }}
      role="presentation"
      style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
    >
      <Typography.Text
        style={{ marginBottom: 0 }}
        copyable={{
          text: rawValue,
          tooltips: showTooltip ? ["Copy", "Copied"] : false,
          icon: [<CopyOutlined key="copy" />, <CheckOutlined key="check" />],
        }}
      >
        {textToShow}
      </Typography.Text>
    </span>
  );
}
